query GetTargetAudience($id: ID!) {
  targetAudience(id: $id) {
    id
    name
    filters {
      id
      filterType
      recordType
      record
    }
  }
}
